export interface OrderStateModel {
  state: string;
}

export const OrderStates: OrderStateModel[] = [
  {
    state: 'pending'
  },
  {
    state: 'processed'
  },
  {
    state: 'canceled'
  }
]

export const OrderStatesActionMessages: { [key: number]: string } = {
  0: 'pending',
  1: 'processed',
  2: 'canceled',
}